module.exports = __webpack_public_path__ + "img/eventov2.ce1bf288.png";